import gql from 'graphql-tag';

import dokkioItemFragment from './dokkioItemFragment';
import integrationEmailFragment from './integrationEmailFragment';
import integrationThreadFragment from './integrationThreadFragment';
import embeddedIntegrationItemFragment from './embeddedIntegrationItemFragment';
import integrationItemHierarchyFragment from './integrationItemHierarchyFragment';
import slackChannelsPageFragment from './slackChannelsPageFragment';

export const integrationItemFragment = gql`
  fragment integrationItemFragment on IntegrationItem {
    ...embeddedIntegrationItemFragment
    hierarchy {
      ...integrationItemHierarchyFragment
    }
    slackChannelsPage {
      ...slackChannelsPageFragment
    }
    dokkioItem {
      ...dokkioItemFragment
    }
    shortcutIntegrationItem {
      ...embeddedIntegrationItemFragment
    }
    integrationEmails {
      ...integrationEmailFragment
    }
    integrationThreads {
      ...integrationThreadFragment
    }
  }
  ${dokkioItemFragment}
  ${integrationEmailFragment}
  ${integrationThreadFragment}
  ${embeddedIntegrationItemFragment}
  ${integrationItemHierarchyFragment}
  ${slackChannelsPageFragment}
`;
export default integrationItemFragment;
